import React, { useContext } from 'react';

import { PairWalletsContext } from 'context/PairWalletsContext/PairWalletsContext';
import { IDexPair } from 'types/pairs';

interface Props {
  dexPair: IDexPair;
}

const TokenQuoteHead: React.FC<Props> = React.memo(({ dexPair }) => {
  const { totalBalances } = useContext(PairWalletsContext);

  return (
    <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
      <span>{dexPair.token_quote.symbol}</span>
      <span>({totalBalances.quote})</span>
    </div>
  );
});

export default TokenQuoteHead;
